export default __webpack_public_path__ + "static/touchfree-kiosk-feedback-collector-558bfcf4d99b12c98fb88e726b005f86.jpg";